module.exports = __webpack_public_path__ + "img/rehan.427df146.jpeg";